import React, {
	useState,
	useEffect
} from 'react';

import {
 	useSelector,
 	useDispatch,
} from 'react-redux';

import { actionFetchSummaryData, actionResetSessionSummaryData } from './actions.js';
import Loading from 'components/loading.js';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import {
	//toDate,
	//zonedTimeToUtc,
	utcToZonedTime,
	format
} from 'date-fns-tz';
//import NavbarCollapse from 'react-bootstrap/NavbarCollapse';

const FormatMa5 = (props) => {//a bit of conditional rendering
	if (props.val === ''){
		return (<></>);
	} else {
		return (<>{ (props.val*1).toFixed(0) }kg</>);
	}
}

const FormatAnimalCount = (props) => {//a bit of conditional rendering
	if (parseInt(props.val) === 0){
		return (<></>);
	} else {
		return (<>{ (props.val*1).toFixed(0) }</>);
	}
}

export const SessionSummary = (props) => {
	/**
	 *
	 *
	 *
	 */

	// Session summary stored in redux store to save home page load speed

	const session = useSelector(state => state.session);
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const sessionSummary = useSelector(state => state.sessionSummary);

	//console.log('session', session);

	useEffect(() => {
		//console.log('session', session)
		if (session.SessionID){
			//console.log('session',session);
			setLoading(true)
			props.handleSessionLoading(true)
			dispatch(actionResetSessionSummaryData())
			//console.log('session', session)
			dispatch(actionFetchSummaryData(session.SessionID, setLoading))
			props.handleSessionLoading(false)
			//setLoading(false)
		}
	},[session, dispatch, props])
	const lhsCol = '5'
	const rhsCol = '7'

	//console.log('session.summ',session.summ)
	//console.log('sessionSummary', sessionSummary)
	//console.log('sessionSummary.adg30',sessionSummary.adg30);

	if (session.SessionID > 0){
		if (loading){
			return (
				<>
					<Alert className="sessSummary" variant={'secondary'} style={{backgroundColor: 'rgb(233,236,239)'}}>
						<Loading loading = { loading } />
					</Alert>
				</>
			)
		} else {
			//console.log('sessionSummary.summ',sessionSummary.summ)
			//if (Object.keys(sessionSummary.summ).length === 0 && sessionSummary.summ.constructor === Object){
			if (sessionSummary.summ === undefined){
				return (
					<>
						<Alert className="sessSummary" variant={'secondary'} style={{backgroundColor: 'rgb(233,236,239)'}}>
						No data available for Session summary!
						</Alert>
					</>
				)
			} else {
				//
				const totalRecordsF = sessionSummary.summ.TotalRecords.toLocaleString('en');

				//console.log('sessionSummary', sessionSummary);
				return (
					<Alert className="sessSummary container" variant={'secondary'} style={{backgroundColor: 'rgb(233,236,239)'}}>
						{/* <Container fluid> */}
						<h5>{ sessionSummary.summ.SessionName }</h5>
						<span className="startDate">(from { format(utcToZonedTime(sessionSummary.summ.sessionStartUtc, sessionSummary.summ.timezone),'d/MM/yy', {timeZone: sessionSummary.summ.timezone}) })</span>
						{/*
						<Row>
							<Col sm={ lhsCol }>Timezone:</Col>
							<Col sm={ rhsCol }>{ sessionSummary.summ.timezone }</Col>
						</Row>
						<Row>
							<Col className="label" sm={ lhsCol }>Session Start:</Col>
							<Col className="value" sm={ rhsCol }>{ format(utcToZonedTime(sessionSummary.summ.sessionStartUtc, sessionSummary.summ.timezone),'d MMM yyyy HH:mm zzz', {timeZone: sessionSummary.summ.timezone}) }</Col>
						</Row>
						*/}
						<Row>
							<Col className="label" sm={ lhsCol }>Time of last record:</Col>
							<Col className="value" sm={ rhsCol }>{ format(utcToZonedTime(sessionSummary.summ.lastRecordUtc, sessionSummary.summ.timezone),'do MMM yy, HH:mm ', {timeZone: sessionSummary.summ.timezone}) } { sessionSummary.summ.timezone }</Col>
						</Row>
						<Row>
							<Col className="label" sm={ lhsCol }>Total records:</Col>
							<Col className="value" sm={ rhsCol }>{ totalRecordsF }</Col>
						</Row>
						<Row>
							<Col className="label" sm={ lhsCol }>Animals weighed:</Col>
							<Col className="value" sm={ rhsCol }>{ sessionSummary.summ.AnimalsWeighed } of { sessionSummary.summ.Head } = { (sessionSummary.summ.PercentWeighed*100).toFixed(0) }%</Col>
						</Row>
						<Row>
							<Col className="label" sm={ lhsCol }>Current weight range:</Col>
							<Col className="value" sm={ rhsCol }>
								<Row>
									{/* <Col>Min:</Col> <Col> { (sessionSummary.ma5.maMinWt*1).toFixed(0) } */}
									<Col>Min:</Col>
									<Col>
										<FormatMa5 val = { sessionSummary.ma5.ma5Min } />
									</Col>
								</Row>
								<Row>
									<Col>Avg:</Col>
									<Col>
										<FormatMa5 val = { sessionSummary.ma5.ma5 } />
									 </Col>
								</Row>
								<Row>
									<Col>Max:</Col>
									<Col>
										<FormatMa5 val = { sessionSummary.ma5.ma5Max } />
									 </Col>
								</Row>
							</Col>
						</Row>

						<Row style={{textAlign: 'right'}}>
							{/* <Col className="label" sm={ lhsCol }>Average daily gain</Col>
							<Col className="value" sm={ rhsCol }> */}
							<Col sm={ 12 }>
								{/* <Row>
									<Col className="label" style={{textAlign: 'left'}}>Average daily gain</Col>
								</Row> */}
								<hr style={{ height:'0.1rem', background: 'black'}}/>
								<Row>
									<Col className="label" style={{textAlign: 'left'}}>Average daily gain</Col>
									<Col>ADG [kg]</Col>
									<Col>Animals</Col>
									<Col>Days</Col>
								</Row>
								<hr />
								<Row>
									<Col className="label">Last 30 days:</Col>
									<Col className="value">{ sessionSummary.adg30.ADG ? sessionSummary.adg30.ADG + "kg" : '' } </Col>
									<Col className="value"><FormatAnimalCount val={ sessionSummary.adg30.animalCount } /></Col>
									<Col className="value">{ sessionSummary.adg30.days || '' }</Col>
								</Row>
								<Row>
									<Col className="label">Last 90 days:</Col>
									{ sessionSummary.adg90.days !== sessionSummary.adg30.days 
										? 
											<> 
												<Col className="value"> { sessionSummary.adg90.ADG 
													? sessionSummary.adg90.ADG + "kg" : '' } </Col> 
												<Col className="value">< FormatAnimalCount val={ sessionSummary.adg90.animalCount} /></Col>
												<Col className="value">{ sessionSummary.adg90.days || '' }</Col>
											</>
										:
											<>
												<Col className="value"></Col> 
												<Col className="value"></Col>
												<Col className="value"></Col>
		
											</>
										}
								</Row>
								<Row>
									<Col className="label">Last 180 days:</Col>
									{ (sessionSummary.adg180.days !== sessionSummary.adg90.days) 
										? 
											<> 
												<Col className="value"> { sessionSummary.adg180.ADG 
													? sessionSummary.adg90.ADG + "kg" : '' } </Col> 
												<Col className="value">< FormatAnimalCount val={ sessionSummary.adg180.animalCount} /></Col>
												<Col className="value">{ sessionSummary.adg180.days || '' }</Col>
											</>
										:
											<>
												<Col className="value"></Col> 
												<Col className="value"></Col>
												<Col className="value"></Col>
		
											</>
										}
								</Row>
								<Row>
									<Col className="label">All Data:</Col>
									<Col className="value">{ sessionSummary.adgAll.ADG ? sessionSummary.adgAll.ADG + "kg" : '' } </Col>
									<Col className="value"><FormatAnimalCount val={ sessionSummary.adgAll.animalCount } /></Col>
									<Col className="value">{ sessionSummary.adgAll.days || '' }</Col>
								</Row>
							</Col>
						</Row>
						{/* { sessionSummary.Client } */}
						{/* </Container> */}
					</Alert>
				)
			}
		}
	} else {
		return (
			<Alert variant={'secondary'} style={{backgroundColor: 'rgb(233,236,239)'}}>
			<p style={{textAlign: 'center',fontWeight: 'bold'}}>Select a Session to get summary data.</p>
			</Alert>
		)
	}
}